import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Input, TextErrorInput, Button } from '@provi/provi-components'
import { Form } from '../../../components/form'
import { validateFullName } from '../../../utils/validators'

export const Formik = props => {
  const { handleChange, values, errors, touched, handleBlur, handleSubmit } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        cy="input-full-name"
        autoFocus
        margin="normal"
        id="name"
        placeholder="Digite seu nome completo"
        onChange={handleChange('fullName')}
        onBlur={handleBlur('fullName')}
        error={!!errors.fullName}
        value={values.fullName}
      />
      {errors.fullName && touched.fullName && <TextErrorInput cy="error-full-name" text={errors.fullName} />}

      <Button
        marginHorizontal={0}
        type="submit"
        disabled={!validateFullName(values.fullName)}
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFomik = withFormik({
  validateOnBlur: true,
  validateOnChange: false,
  enableReinitialize: true,
  mapPropsToValues: props => ({ fullName: props.data || '' }),
  validationSchema: Yup.object().shape({
    fullName: Yup.string().test({
      name: 'fullName',
      message: 'Digite um nome válido',
      test: fullName => validateFullName(fullName)
    })
  }),
  handleSubmit: async ({ fullName }, { setSubmitting, props }) => {
    props.goToNextScreen(fullName)
    setSubmitting(false)
  }
})(Formik)
